import { DrugActivitiesToTrackEnum } from "../../interfaces/DrugActivitiesToTrackEnum";

export class CreatePioneerRxIntegration {
    static readonly type = '[Settings] Toggle PioneerRx Integration';
    constructor(public payload: any) {
    }
}

export class GetDrugsOfInterest {
    static readonly type = '[Drugs] Get Drugs Of Interest';
  
    constructor(public type?: DrugActivitiesToTrackEnum) {
    }
}

export class SaveInventoryLocation {
    static readonly type = '[Settings] Save Inventory Location';
  
    constructor(public payload: {pin: number, name: string, description?: string, id?: string} ) {
    }
}

export class RemoveInventoryLocation {
    static readonly type = '[Settings] Remove Inventory Location';
  
    constructor(public id: string) {
    }
}

export class UpdateActivityForInventoryLocation {
    static readonly type = '[Settings] Update Activity For InventoryLocation';
  
    constructor(public payload: any) {
    }
}

export class InitiateFrameworkLtcIntegration {
    static readonly type = '[Settings] Initiate Framework LTC Integration';
    constructor(public pin: number) {
    }
}
  